export default __webpack_public_path__ + "static/media/bigBoardBackground.53f4e689.svg";